import axiosInstance from "../../utils/axiosInstance";
import { getAuthHeaders } from "../../utils/authHeader";

const BASE_URL = `/knowledge-base`;

export const fetchKnowledgeBases = async (accountId) => {
  const res = await axiosInstance.get(`${BASE_URL}/account/${accountId}`, getAuthHeaders());
  return res.data;
};

export const createKnowledgeBase = async (knowledgeBase) => {
  const res = await axiosInstance.post(`${BASE_URL}`, knowledgeBase, {
    ...getAuthHeaders(),
    headers: {
      ...getAuthHeaders().headers,
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

export const updateKnowledgeBase = async (uuid, knowledgeBase) => {
  const res = await axiosInstance.put(`${BASE_URL}/${uuid}`, knowledgeBase, {
    ...getAuthHeaders(),
    headers: {
      ...getAuthHeaders().headers,
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

export const deleteKnowledgeBase = async (uuid) => {
  const res = await axiosInstance.delete(`${BASE_URL}/${uuid}`, getAuthHeaders());
  return res.data;
};
